import { Box, CircularProgress } from '@mui/material';

// Full-screen centered spinner shown while Clerk initializes
function Loader() {
    return (
        <Box
            sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: '100vh',
                backgroundColor: '#0d0d1a',
            }}
        >
            <CircularProgress sx={{ color: '#66b2ff' }} />
        </Box>
    );
}

export default Loader;
